// @flow
import { RutasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    ruta: {},
    listaRutas: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type RutasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { ruta?: {} | null, listaRutas?: [] | null, loading?: boolean, +value ?: boolean };

const Rutas = (state: State = INIT_STATE, action: RutasAction): any => {
    // console.log(action);
    switch (action.type) {
        case RutasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RutasActionTypes.GET_RUTA: {
                    return {
                        ...state,
                        ruta: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RutasActionTypes.LIST_RUTAS: {
                    return {
                        ...state,
                        listaRutas: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RutasActionTypes.ADD_RUTA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RutasActionTypes.UPDATE_RUTA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RutasActionTypes.DELETE_RUTA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RutasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case RutasActionTypes.GET_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        ruta: {},
                        loading: false,
                    };
                }
                case RutasActionTypes.LIST_RUTAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaRutas: [],
                        loading: false,
                    };
                }
                case RutasActionTypes.ADD_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RutasActionTypes.UPDATE_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RutasActionTypes.DELETE_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RutasActionTypes.GET_RUTA:
            return { ...state, error: false, loading: true };
        case RutasActionTypes.LIST_RUTAS:
            return { ...state, error: false, loading: true };
        case RutasActionTypes.ADD_RUTA:
            return { ...state, error: false, loadingForm: true };
        case RutasActionTypes.UPDATE_RUTA:
            return { ...state, error: false, loadingForm: true };
        case RutasActionTypes.DELETE_RUTA:
            return { ...state, error: false, loading: true };
        case RutasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                ruta: {},
                listaRutas: [],
                formSubmited: false
            };
        case RutasActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Rutas;
